import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MDBModalRef } from 'angular-bootstrap-md';
import { Subject } from 'rxjs';
import { Config } from '../../services/env.config';

@Component({
  selector: 'app-scheme-popup',
  templateUrl: './scheme-popup.component.html',
  styleUrls: ['./scheme-popup.component.scss']
})
export class SchemePopupComponent implements OnInit {

  action = new Subject();
  message: string;
  data: any;
  constructor(public modalRef: MDBModalRef, private http: HttpClient) { }

  ngOnInit() {
  }
  close() {
    this.action.next('OK');
  }
  cpHeaders = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Content-Security-Policy': 'default-src \'self\'; script-src \'self\'; style-src \'self\' \'unsafe-inline\'',
      'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
      'X-Frame-Options': 'DENY',
      'X-Content-Type-Options': 'nosniff',
      'Referrer-Policy': 'strict-origin-when-cross-origin',
      'Permissions-Policy': 'geolocation=(self), camera=(self),microphone=(self),payment=(self),usb=(self),accelerometer=(self)'
    })
  };



  ViewScheme(id)  {
    let data = JSON.parse(sessionStorage.getItem('user')) ;
    let user = { UserName : data.UserName , SchemeMgmtId: id } ;
    return this.http
      .post(Config.BaseEndpoint + '/DownloadFile', JSON.stringify(user), this.cpHeaders)
      .toPromise()
      .then((data: any) => {
        if (data.FileData) {
            // Download PDF in Chrome etc.
            const source = `data:application/pdf;base64,${data.FileData}`;
            const link = document.createElement("a");
            link.href = source;
            link.download =data.FileName;
            link.click();
        
        }
       
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

}
